// extracted by mini-css-extract-plugin
export var bottomBar = "narration-module--bottomBar--ThqEf";
export var mobileBar = "narration-module--mobileBar--htyQv";
export var mobileWidth = "767px";
export var playButtonContainer = "narration-module--playButtonContainer--L8NOs";